import {connect} from 'react-redux';

const mapStateToProps = ({SanctionCheckReducer}) => {
  return {
    SanctionCheckReducer,
  };
};

export default connect(mapStateToProps, undefined);
